import React, { useEffect, useState, useCallback } from 'react';
import { Divider, Skeleton, Tooltip } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import lodashGet from 'lodash/get';
import { apiHolder, apis, inWindow, locationHelper, apiHolder as api, util, getIn18Text, } from 'api';
import classNames from 'classnames';
import SendMailPop from './SendMailPop';
import styles from './detail.module.scss';
import { openSession } from '@web-im/common/navigate';
import ContactTrackerIns from '../../tracker';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import { useActions, ContactActions, useAppSelector } from '@web-common/state/createStore';
import ContactDetailInfo from './detail_info';
import MedalInfo from './medal_info';
import ImgPreview from '@web-common/components/UI/ImagePreview';
import { getDisplayEmailInfo, transAvatarSize } from '@web-common/utils/contact_util';
import { useContactModel } from '@web-common/hooks/useContactModel';
import { PersonalModal } from '@web-common/components/UI/SiriusContact/personal/personalModal';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { MailListModal } from '@web-common/components/UI/SiriusContact/mailListModal/mailListModal';
import PersonalMark from '@web-common/components/UI/SiriusContact/personalMark/mark';
import { PrivilegeCheckForMailPlus } from '@/components/UI/PrivilegeEnhance';
import { doUpdateContactMap, refreshContactDataByEmails } from '@web-common/state/reducer/contactReducer';
import { scenes } from '@/components/Layout/CustomsData/components/uniDrawer/uniDrawerLeads2';
import { PublicMailDomainList } from '@web-edm/utils/utils';
import { UniDrawerModuleId, showUniDrawer, Module } from '@lxunit/app-l2c-crm';
import { ReactComponent as QyTag } from '@/images/icons/mail/qyTag.svg';
import { ReactComponent as RightIcon } from '@/images/icons/mail/arrawrightwhite.svg';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const systemApi = apiHolder.api.getSystemApi();
const productApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const ContactDetailInner = props => {
    var _a;
    const { contactId, email, contact, _account, onOperateSuccess, onClickAddContact, refreshKey } = props;
    const [contactModel, setContactModel] = useState(contact);
    const [detailRestricted, setDetailRestricted] = useState(false);
    const [personalModalVisible, setPersonalModalVisible] = useState(false);
    const [isEditPersonalModal, setIsEditPersonalModal] = useState(false);
    const contactActions = useActions(ContactActions);
    const onPersonalOperateSuccess = useCallback(() => {
        setPersonalModalVisible(false);
        onOperateSuccess && onOperateSuccess();
    }, []);
    const handleAddContact = useCallback(() => {
        setPersonalModalVisible(true);
        setIsEditPersonalModal(false);
        contactActions.doCreateFormExternal(contactModel);
        onClickAddContact && onClickAddContact();
    }, [contactModel]);
    const resolvedId = ((_a = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _a === void 0 ? void 0 : _a.id) || contactId;
    const resolvedEmail = contact ? contactApi.doGetModelDisplayEmail(contact) : email;
    useEffect(() => {
        setContactModel(contact);
    }, [contact]);
    useEffect(() => {
        if (!resolvedId) {
            return;
        }
        let cancelled = false;
        contactApi.doGetFullContactByIdWithCallback({
            id: resolvedId,
            email: resolvedEmail,
            _account,
            onData: (models, meta) => {
                if (cancelled || !models.length) {
                    return;
                }
                setContactModel(models[0]);
                if (meta) {
                    doUpdateContactMap(models);
                    if (meta.detailRestricted !== undefined) {
                        setDetailRestricted(meta.detailRestricted);
                    }
                }
            },
        });
        return () => {
            cancelled = true;
        };
    }, [resolvedId, _account, resolvedEmail, refreshKey]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LxDetail, Object.assign({}, props, { contact: contactModel, detailRestricted: detailRestricted, setPersonalModalVisible: setPersonalModalVisible, setIsEditPersonalModal: setIsEditPersonalModal, handleAddContact: handleAddContact })),
        personalModalVisible && (React.createElement(PersonalModal, { contactId: contactId, _account: _account, contact: contactModel, isEdit: isEditPersonalModal, onCancel: () => setPersonalModalVisible(false), onSuccess: () => onPersonalOperateSuccess() }))));
};
const LxDetail = props => {
    var _a, _b;
    const { from = 'other', email, contact, branch = false, dividerLine = true, directSend = true, containerClassName = '', containerStyle = {}, onNavigate, visibleSchedule = true, onNotifyParent, onOperateSuccess, _account = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '', showClose, isMailList, isDeleteManageMailList, isEditManageMailList, isSelectedPersoanlMark, setIsEditPersonalModal, setPersonalModalVisible, handleAddContact, trInfo, detailRestricted, originName, } = props;
    const isMainAccount = ((_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) === _account;
    const [bigAvatar, setBigAvatar] = useState('');
    const [updateMailListModalVisible, setUpdateMailListModalVisible] = useState(false);
    const contactActions = useActions(ContactActions);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const [, setUniToCustomerOrClueParam] = useState2RM('uniToCustomerOrClueParam');
    const detailInfoStyle = from === 'contact' ? { maxWidth: '100%' } : { maxWidth: 320, maxHeight: 200, overflowY: 'auto' };
    const inMainPage = inWindow() && locationHelper.testPathMatch('/');
    useEffect(() => {
        var _a;
        let avatar = (_a = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _a === void 0 ? void 0 : _a.avatar;
        if (avatar) {
            if (!isCorpMail) {
                avatar = transAvatarSize(avatar, 'big');
            }
            setBigAvatar(avatar);
        }
    }, [lodashGet(contact, 'contact.avatar', '')]);
    useEffect(() => {
        ContactTrackerIns.tracker_contact_view_detail();
    }, []);
    const mailListEditSuc = useCallback(() => {
        setUpdateMailListModalVisible(false);
        onOperateSuccess && onOperateSuccess();
    }, []);
    if (!contact) {
        return null;
    }
    const { contactName: _contactName, avatar, id, enableIM, accountName, color = util.getColor(accountName), type, visibleCode, } = contact.contact || {};
    const contactName = type === 'external' ? originName || _contactName : _contactName;
    const getTelOrgMobiles = (contactInfo) => {
        const list = contactInfo.filter(e => e.contactItemType === 'MOBILE' || e.contactItemType === 'TEL');
        const telSet = new Set();
        list.forEach(e => {
            var _a;
            if ((e === null || e === void 0 ? void 0 : e.contactItemVal) && ((_a = e === null || e === void 0 ? void 0 : e.contactItemVal) === null || _a === void 0 ? void 0 : _a.trim())) {
                telSet.add(e === null || e === void 0 ? void 0 : e.contactItemVal);
            }
        });
        return [...telSet];
    };
    const getEmailList = (contactInfo, accountName) => {
        const list = getDisplayEmailInfo(contactInfo);
        const emailSet = new Set();
        list.forEach(e => {
            var _a;
            if ((e === null || e === void 0 ? void 0 : e.contactItemVal) && ((_a = e === null || e === void 0 ? void 0 : e.contactItemVal) === null || _a === void 0 ? void 0 : _a.trim())) {
                emailSet.add(e === null || e === void 0 ? void 0 : e.contactItemVal);
            }
        });
        if (emailSet.size <= 0) {
            emailSet.add(accountName);
        }
        return [...emailSet];
    };
    const isOpenSeaCustomer = lodashGet(contact, 'customerOrgModel.role', '') === 'openSeaCustomer';
    const contactInfo = contact.contactInfo || [];
    const visibleIM = enableIM && !isSelectedPersoanlMark && inMainPage && isMainAccount && nimApi.getIMAuthConfig();
    const isPersonal = type === 'personal';
    const visAddToContact = !isSelectedPersoanlMark && (type === 'external' || isOpenSeaCustomer);
    const visAddCustomer = isMainAccount && (['personal', 'external'].includes(type) || isOpenSeaCustomer);
    const visAddToExistedCustomer = isMainAccount && (['personal', 'external'].includes(type) || isOpenSeaCustomer);
    const visibleMailRelated = false;
    const visibleEdit = (type === 'personal' && !isSelectedPersoanlMark) || (type === 'enterprise' && (isDeleteManageMailList || isEditManageMailList));
    const visibleDelete = (type === 'personal' && !isSelectedPersoanlMark) || (type === 'enterprise' && isDeleteManageMailList);
    const visibleExtraOp = from === 'contact' && (visibleEdit || visibleDelete);
    const displayEmail = contactApi.doGetModelDisplayEmail(contact);
    const tooltipContainer = () => document.getElementById(id) || document.body;
    const telOrMobiles = getTelOrgMobiles(contactInfo);
    const emailList = getEmailList(contactInfo, accountName);
    const handleAddCustomer = () => {
        onNotifyParent && onNotifyParent();
        trackApi.track('waimao_mail_view_contactsDetailPage​_action', { action: 'addCustomer' });
        const emailDomain = (email === null || email === void 0 ? void 0 : email.split('@')[1]) || '';
        const webapp = PublicMailDomainList.includes(emailDomain) ? '' : emailDomain;
        showUniDrawer({
            moduleId: UniDrawerModuleId.CustomerDetail,
            moduleProps: {
                visible: true,
                onClose: () => { },
                onSuccess: () => {
                    refreshContactDataByEmails({
                        [_account]: [accountName],
                    }, new Map([[accountName, contactName]]));
                },
                customerData: {
                    company_name: '',
                    website: webapp,
                    contact_list: [
                        {
                            condition: 'company',
                            contact_name: contactName,
                            email: accountName,
                        },
                    ],
                },
                source: 'mailListStranger',
                drawerIdentify: {
                    module: Module.Email,
                    opType: 'create',
                },
                minimize: true,
                bodyContainer: document.querySelector('#mailboxModule'),
            },
        });
    };
    const addToExistedCustomers = () => {
        trackApi.track('waimao_mail_view_contactsDetailPage​_action', { action: 'existingCustomer' });
        onNotifyParent && onNotifyParent();
        const { contact: contactObj } = contact;
        const { contactName, accountName, displayEmail } = contactObj;
        const email = displayEmail || accountName;
        setUniToCustomerOrClueParam({
            visible: true,
            type: 'customer',
            way: scenes.Email_stranger_card,
            contacts: [
                {
                    email,
                    contact_name: contactName || email,
                },
            ],
            onOk: () => {
                refreshContactDataByEmails({
                    [_account]: [email],
                }, new Map([[email, contactName]]));
            },
        });
    };
    const sendMsg = async (contactInfo) => {
        var _a;
        const toAccount = ((_a = contactInfo.find(item => item.contactItemType === 'yunxin')) === null || _a === void 0 ? void 0 : _a.contactItemVal) || '';
        if (onNavigate) {
            onNavigate();
        }
        openSession({
            sessionId: `p2p-${toAccount}`,
            mode: 'normal',
        }, {
            createSession: true,
            validateTeam: false,
        });
    };
    const checkMailRelated = (data) => {
        mailConfApi.doOpenRelatedPage(data);
    };
    const imgPreview = (url) => {
        ImgPreview.preview({
            data: [
                {
                    downloadUrl: url,
                    previewUrl: url,
                    OriginUrl: url,
                    size: 480,
                },
            ],
            startIndex: 0,
        });
    };
    const handleDel = async () => {
        if (type === 'personal') {
            mailConfApi.getAccountBanSetting(_account).then(res => {
                if (!res.ban_del_contact) {
                    SiriusModal.error({
                        title: getIn18Text('QUEDINGYAOSHANCHU11'),
                        content: getIn18Text('LIANXIRENHUIZAI'),
                        onOk: async () => {
                            ContactTrackerIns.tracker_contact_detail_click(getIn18Text('SHANCHU'), '联系人详情页');
                            const { success, reason = getIn18Text('SHANCHUSHIBAI') } = await contactApi.doDeleteContact({
                                accountIdList: [contact.contact.id],
                                _account,
                            });
                            if (success) {
                                onOperateSuccess && onOperateSuccess();
                                message.success(getIn18Text('SHANCHUCHENGGONG'));
                            }
                            else {
                                message.error(reason);
                            }
                        },
                    });
                }
                else {
                    message.warn(getIn18Text('MEIYOUSHANCHUQUANXIAN，'));
                }
            });
            return;
        }
        if (type === 'enterprise' && isDeleteManageMailList) {
            SiriusModal.error({
                title: (React.createElement("div", { className: styles.delMailListTitle },
                    getIn18Text('QUERENSHANCHU“'),
                    React.createElement("span", { className: styles.contactNameTitle }, contactName),
                    getIn18Text('”YOUJIANLIEBIAOMA？'))),
                content: '',
                onOk: async () => {
                    ContactTrackerIns.tracker_contact_detail_click(getIn18Text('SHANCHU'), '联系人详情页');
                    const accountArr = accountName.split('@');
                    if (!(accountArr === null || accountArr === void 0 ? void 0 : accountArr.length))
                        return;
                    const delRes = await contactApi.deleteMaillist({
                        account_name: accountArr[0],
                        domain: accountArr[1],
                        id,
                    });
                    console.log('delresdelres', delRes);
                    const { success, message: msg, code } = delRes;
                    if (success) {
                        message.success(getIn18Text('SHANCHUCHENGGONG'));
                    }
                    else {
                        if (code === 400) {
                            message.error('您没有删除该邮件列表的权限');
                        }
                        else {
                            message.error(msg || getIn18Text('SHANCHUSHIBAI'));
                        }
                    }
                },
            });
        }
    };
    const handleEdit = (fromType) => {
        if (type === 'personal') {
            setPersonalModalVisible(true);
            setIsEditPersonalModal(true);
            fromType === 'detail' && ContactTrackerIns.tracker_contact_detail_click(getIn18Text('BIANJI'), '联系人详情页');
            return;
        }
        if (visibleEdit || visibleDelete) {
            setUpdateMailListModalVisible(true);
            ContactTrackerIns.tracker_contact_detail_click(getIn18Text('BIANJI'), '邮件列表详情页');
        }
    };
    const sendMailBuryPoint = () => {
        if (type === 'personal') {
            ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FAYOUJIAN'), '联系人详情页');
            return;
        }
        if (type === 'enterprise') {
            if (isMailList) {
                ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FAYOUJIAN'), '邮件列表详情页');
            }
            else {
                ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FAYOUJIAN'), '联系人详情页');
            }
            return;
        }
        ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FAYOUJIAN'), '');
    };
    const sendIcon = (React.createElement(Tooltip, { getPopupContainer: tooltipContainer, overlayClassName: styles.tooltipOverlay, title: getIn18Text('FAYOUJIAN'), placement: "bottom" },
        React.createElement("i", { className: classNames(styles.icon, styles.iconSendEmail), onClick: sendMailBuryPoint })));
    const renderContactAvatarWrap = (React.createElement("div", { className: styles.contactAvatarWrap },
        React.createElement("div", { className: styles.contactAvatar },
            React.createElement(AvatarTag, { size: 120, contactId: id, showPendant: type === 'enterprise', user: {
                    name: contactName,
                    avatar,
                    email: id,
                    color,
                } })),
        React.createElement("div", { className: styles.contactAvatarInfo },
            React.createElement("div", { className: styles.contactAvatarInfoName },
                React.createElement("span", null, contactName || lodashGet(displayEmail.split('@'), '[0]', displayEmail))),
            React.createElement("div", { className: styles.contactIconGroup },
                React.createElement(SendMailPop, { mailList: emailList, _account: _account },
                    React.createElement("div", { className: styles.btnWrap, "data-test-id": "contact_detail_btn_mail" }, getIn18Text('FAYOUJIAN'))),
                visibleMailRelated && (React.createElement(React.Fragment, null,
                    React.createElement(Tooltip, { getPopupContainer: tooltipContainer, overlayClassName: styles.tooltipOverlay, title: React.createElement("span", null, getIn18Text('WANGLAIYOUJIAN')), placement: "bottom" },
                        React.createElement("i", { className: classNames(styles.icon, styles.iconMailRelated), "data-test-id": "contact_detail_btn_related", onClick: () => {
                                checkMailRelated(contact);
                                onNotifyParent && onNotifyParent();
                            } })))),
                visibleIM && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.btnWrap, "data-test-id": "contact_detail_btn_im", onClick: () => {
                            sendMsg(contactInfo);
                            onNotifyParent && onNotifyParent();
                            ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FAXIAOXI'));
                        } }, getIn18Text('FAXIAOXI')))),
                visAddToContact && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.btnWrap, "data-test-id": "contact_detail_btn_add", onClick: () => {
                            contactActions.doCreateFormExternal(contact);
                        } }, getIn18Text('TIANJIATONGXUNLU')))),
                visibleExtraOp && (React.createElement(React.Fragment, null,
                    visibleEdit && (React.createElement("div", { className: styles.btnWrap, "data-test-id": "contact_detail_btn_edit", onClick: () => handleEdit('detail') }, getIn18Text('BIANJI'))),
                    visibleDelete && (React.createElement("div", { className: styles.btnWrap, "data-test-id": "contact_detail_btn_delete", onClick: handleDel }, getIn18Text('SHANCHU'))))),
                isPersonal && (React.createElement(PersonalMark, { size: 20, useId: true, contactId: id, testId: "contact_detail_btn_mark", email: displayEmail || accountName, visibleToolTip: false, useText: true, visibleHover: false, canOperate: type === 'personal', onMarked: (marked) => {
                        ContactTrackerIns.tracker_contact_personal_mark_startIcon_click('通讯录-个人联系人详情页标星', marked);
                    }, className: styles.btnWrap })))),
        dividerLine && React.createElement(Divider, null)));
    const renderAvatarWrap = (React.createElement("div", { className: styles.avatarContainer, onClick: () => {
            bigAvatar && imgPreview(bigAvatar);
        }, style: avatar ? { cursor: 'zoom-in' } : {} },
        React.createElement("div", { className: styles.avatar }, avatar ? (React.createElement("img", { src: bigAvatar, onError: () => {
                setBigAvatar(old => old.replace('480x480', '180x180'));
            }, className: styles.avatarImg, alt: "" })) : (React.createElement("div", { className: styles.avatarColor, style: { backgroundColor: color } }))),
        React.createElement("div", { className: styles.avatarMask }),
        showClose && (React.createElement("div", { className: styles.closeIcon, onClick: e => {
                onNotifyParent && onNotifyParent();
                e.stopPropagation();
            } })),
        React.createElement("div", { className: styles.avatarInfoWrap },
            React.createElement("div", { className: styles.contactName },
                React.createElement("div", { className: styles.contactNameLabel },
                    contactName || accountName,
                    " "),
                React.createElement(PersonalMark, { size: 24, contactId: id, email: displayEmail || accountName, canOperate: type === 'personal', testId: "contact_detail_btn_mark", onMarked: (marked) => {
                        const source = type === 'personal' ? '个人通讯录联系人卡片' : '企业通讯录联系人卡片';
                        ContactTrackerIns.tracker_contact_personal_mark_startIcon_click(source, marked);
                    }, visibleHover: false, visibleToolTip: type !== 'personal' ? getIn18Text('toPersonalCancel') : true, useCardIcon: true, noMarkedHidden: type !== 'personal', style: { marginLeft: 8, width: 32, height: 32 } }),
                visibleCode === 4 && React.createElement("div", { className: styles.contactDisabled }, getIn18Text('TINGYONG'))),
            (trInfo === null || trInfo === void 0 ? void 0 : trInfo.name) && (trInfo === null || trInfo === void 0 ? void 0 : trInfo.status) == 1 ? (React.createElement("div", { className: styles.trNameWrap, onClick: () => {
                    if (trInfo && trInfo.infoUrl) {
                        if (systemApi.isElectron()) {
                            systemApi.openNewWindow(trInfo.infoUrl, false);
                        }
                        else {
                            window.open(trInfo.infoUrl, '_blank');
                        }
                    }
                } },
                React.createElement(QyTag, null),
                React.createElement("span", { className: styles.trName, style: { margin: '0 5px' } }, trInfo === null || trInfo === void 0 ? void 0 : trInfo.name),
                React.createElement(RightIcon, null))) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: styles.iconGroup },
                React.createElement("div", { className: styles.iconWrap, onClick: e => {
                        onNotifyParent && onNotifyParent();
                        e.stopPropagation();
                    } },
                    React.createElement(SendMailPop, { mailList: emailList, testId: "contact_detail_btn_mail", _account: _account },
                        React.createElement("i", { className: classNames(styles.icon, styles.iconSendEmail) })),
                    React.createElement("div", { className: styles.iconTxt }, getIn18Text('FAYOUJIAN'))),
                visibleMailRelated && (React.createElement("div", { className: styles.iconWrap },
                    React.createElement("i", { className: classNames(styles.icon, styles.iconMailRelated), "data-test-id": "contact_detail_btn_related", onClick: e => {
                            e.stopPropagation();
                            onNotifyParent && onNotifyParent();
                            checkMailRelated(contact);
                        } }),
                    React.createElement("div", { className: styles.iconTxt }, getIn18Text('WANGLAIYOUJIAN')))),
                visibleIM && (React.createElement("div", { className: styles.iconWrap },
                    React.createElement("i", { className: classNames(styles.icon, styles.iconSendMessage), "data-test-id": "contact_detail_btn_im", onClick: e => {
                            e.stopPropagation();
                            sendMsg(contactInfo);
                            onNotifyParent && onNotifyParent();
                            ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FAXIAOXI'));
                        } }),
                    React.createElement("div", { className: styles.iconTxt }, getIn18Text('FAXIAOXI')))),
                visibleEdit && (React.createElement("div", { className: styles.iconWrap },
                    React.createElement("i", { className: classNames(styles.icon, styles.editContactLight), "data-test-id": "contact_detail_btn_edit", onClick: e => {
                            e.stopPropagation();
                            handleEdit('card');
                        } }),
                    React.createElement("div", { className: styles.iconTxt }, getIn18Text('BIANJILIANXIREN')))),
                visAddToContact && (React.createElement("div", { className: styles.iconWrap },
                    React.createElement("i", { onClick: e => {
                            e.stopPropagation();
                            handleAddContact();
                        }, className: classNames(styles.icon, styles.iconAddContact), "data-test-id": "contact_detail_btn_add" }),
                    React.createElement("div", { className: styles.iconTxt }, getIn18Text('TIANJIATONGXUNLU')))),
                visAddCustomer && (process.env.BUILD_ISEDM || navigateVersion) && productApi.getABSwitchSync('edm_mail') && (React.createElement("div", { className: styles.iconWrap },
                    React.createElement(PrivilegeCheckForMailPlus, { accessLabel: "OP", resourceLabel: "CONTACT" },
                        React.createElement("i", { onClick: e => {
                                e.stopPropagation();
                                handleAddCustomer();
                            }, className: classNames(styles.icon, styles.iconCreateCustomer), "data-test-id": "contact_detail_btn_addCustomer" })),
                    React.createElement("div", { className: styles.iconTxt }, getIn18Text('addCustomer')))),
                visAddToExistedCustomer && (process.env.BUILD_ISEDM || navigateVersion) && productApi.getABSwitchSync('edm_mail') && (React.createElement("div", { className: styles.iconWrap },
                    React.createElement(PrivilegeCheckForMailPlus, { accessLabel: "OP", resourceLabel: "CONTACT" },
                        React.createElement("i", { onClick: e => {
                                e.stopPropagation();
                                addToExistedCustomers();
                            }, className: classNames(styles.icon, styles.iconAddToContact), "data-test-id": "contact_detail_btn_addToCustomer" })),
                    React.createElement("div", { className: styles.iconTxt }, getIn18Text('TIANJIADAOYIYOUKEHU'))))))));
    const normalContent = (React.createElement("div", { "data-test-id": from === 'contact' ? 'contac_detail_content' : 'contac_detail_content_card', id: id, style: containerStyle, className: classNames(styles.detailContainer, containerClassName) },
        from === 'contact' ? renderContactAvatarWrap : renderAvatarWrap,
        type === 'enterprise' && !isMailList && !(process.env.BUILD_ISEDM || navigateVersion) && React.createElement(MedalInfo, Object.assign({}, { from, contact })),
        React.createElement("div", { style: detailInfoStyle },
            React.createElement(ContactDetailInfo, { contact: contact, branch: branch, isMainAccount: isMainAccount, directSend: directSend, emailList: emailList, phoneList: telOrMobiles, visibleSchedule: !isMailList && visibleSchedule, onNotifyParent: onNotifyParent, _account: _account, detailRestricted: detailRestricted }))));
    return (React.createElement(Skeleton, { active: true, avatar: true, loading: accountName === '', paragraph: { rows: 4 } },
        React.createElement("div", { "data-test-id": "contac_detail", className: styles.contactDetailWrap, onClick: e => {
                e.stopPropagation();
            } },
            normalContent,
            updateMailListModalVisible && (React.createElement(MailListModal, { id: id, purpose: "update", email: accountName, onCancel: () => setUpdateMailListModalVisible(false), onSuccess: () => mailListEditSuc() })))));
};
const ContactDetail = props => {
    const { contactId, email, contact, _account, originName, useIdFirst } = props;
    const model = useContactModel({
        contactId: contactId,
        email: email,
        name: originName || (contact === null || contact === void 0 ? void 0 : contact.contact.contactName),
        useIdFirst,
        _account,
    });
    return React.createElement(ContactDetailInner, Object.assign({}, props, { contact: model, contactId: (model === null || model === void 0 ? void 0 : model.contact.id) || contactId, email: (model === null || model === void 0 ? void 0 : model.contact.accountName) || email }));
};
export default ContactDetail;
